import { create } from "zustand";

export const useStoreCRMConfig = create((set, get) => ({
  savedCRMConfig: [],
  savedCompanyConfig: [],
  savedCompanyConfigWithWritePermission: [],
  savedCompanyConfigObj: {},
  savedPeopleConfig: [],
  savedPeopleConfigWithWritePermission: [],
  savedVoiceNotesConfig: [],
  savedVoiceNotesConfigWithWritePermission: [],

  setSavedCRMConfig: (data) => {
    const companyConfig = data?.filter((item) => item.type === "company") || [];
    const peopleConfig = data?.filter((item) => item.type === "person") || [];
    const voiceNotesConfig = data?.filter((item) => item.type === "voice_call") || [];

    const companyObj = data?.find((item) => item.type === "company") || {};

    const companyConfigWithWritePermission = data?.filter(
      (obj) => obj.type === "company" && obj.permission?.create === true
    );
    const peopleConfigWithWritePermission = data?.filter(
      (obj) => obj.type === "person" && obj.permission?.create === true
    );
    const voiceNotesConfigWithWritePermission = data?.filter(
      (obj) => obj.type === "voice_call" && obj.permission?.create === true
    );

    set({
      savedCRMConfig: data || [],
      savedCompanyConfig: companyConfig,
      savedPeopleConfig: peopleConfig,
      savedVoiceNotesConfig: voiceNotesConfig,
      savedCompanyConfigObj: companyObj,
      savedCompanyConfigWithWritePermission: companyConfigWithWritePermission,
      savedPeopleConfigWithWritePermission: peopleConfigWithWritePermission,
      savedVoiceNotesConfigWithWritePermission: voiceNotesConfigWithWritePermission,
    });
  },
}));
